import { Instagram, Facebook, Linkedin, Film, Image as ImageIcon, Circle } from "lucide-react";

export const STATUS_META = {
  ready: { label: "Ready to publish", color: "#5F8213", bg: "rgba(147,192,32,.15)" },
  scheduled: { label: "Scheduled", color: "#2F6BFF", bg: "rgba(47,107,255,.12)" },
  completed: { label: "Published", color: "#5F8213", bg: "rgba(147,192,32,.15)" },
  attention: { label: "Requires attention", color: "#D0526B", bg: "rgba(208,82,107,.12)" },
  failed: { label: "Failed", color: "#D0526B", bg: "rgba(208,82,107,.12)" },
  skipped: { label: "Skipped", color: "#9A9C90", bg: "rgba(154,156,144,.16)" },
  awaiting_approval: { label: "Awaiting approval", color: "#B8892B", bg: "rgba(184,137,43,.15)" },
};

export const PRIORITY_META = {
  high: { label: "High", color: "#D0526B", bg: "rgba(208,82,107,.12)" },
  medium: { label: "Medium", color: "#B8892B", bg: "rgba(184,137,43,.15)" },
  low: { label: "Low", color: "#6B6E62", bg: "rgba(107,110,98,.10)" },
};

export const METHOD_META = {
  AUTO: { label: "Auto", color: "#5F8213", bg: "rgba(147,192,32,.15)", desc: "Big Growth can publish directly — approve to schedule." },
  ASSISTED: { label: "Assisted", color: "#2F6BFF", bg: "rgba(47,107,255,.12)", desc: "Prepared for you — complete the manual steps, then publish." },
  MANUAL: { label: "Manual", color: "#B8892B", bg: "rgba(184,137,43,.15)", desc: "Publish natively in-app using the checklist and content below." },
};

export const PLATFORM_ICON = { Instagram, Facebook, LinkedIn: Linkedin };
export const FORMAT_ICON = { Reel: Film, Story: Circle, Feed: ImageIcon };

export const ROLES = [
  { key: "operator", label: "Managed Agent", hint: "Front-line operator" },
  { key: "team_leader", label: "Team Leader", hint: "Manages a pod" },
  { key: "manager", label: "Managed Team", hint: "Management & commercials" },
];

export const can = (role, cap) => {
  const caps = {
    operator: ["today", "queue", "attention", "branches", "task", "ai"],
    team_leader: ["today", "queue", "attention", "branches", "task", "ai", "team"],
    manager: ["today", "queue", "attention", "branches", "task", "ai", "team", "capacity", "management"],
  };
  return (caps[role] || caps.operator).includes(cap);
};

export const platformIcon = (p) => PLATFORM_ICON[p] || Circle;
